import {ILeaderboardProps} from "@game/ui/interface/ILeaderBoardProps";
import {LeaderBoard} from "@game/ui/leaderboard/LeaderBoard";
import {ServerLeaderBoard} from "@game/ui/leaderboard/ServerLeaderBoard";
import "./LeaderBoardTabs.less";

type LeaderBoardTabsProps = {
    activeTab: number;
    leaderboardsProps: ILeaderboardProps;
    className?: string;
};

export const LeaderBoardTabs = (props: LeaderBoardTabsProps) => {
    if (__SOCIAL__ !== "tg") {
        return <LeaderBoard {...props.leaderboardsProps} />;
    }

    return <ServerLeaderBoard />;
};
